import React, { useState } from "react";
import { useAppUpdate } from "@/pwa/updateStore";
import { getAppBranding } from "@/utils/appBranding";
import "./AppUpdatePrompt.css";

export default function AppUpdatePrompt() {
  const update = useAppUpdate();
  const [updating, setUpdating] = useState(false);
  const [failed, setFailed] = useState(false);

  if (!update) return null;

  const handleUpdate = async () => {
    setUpdating(true);
    setFailed(false);
    try {
      await update();
    } catch {
      setFailed(true);
    } finally {
      setUpdating(false);
    }
  };

  return (
    <section className="app-update-prompt" aria-label="App update">
      <div role="status" aria-live="polite" className="app-update-prompt__copy">
        <h2>Update available</h2>
        <p>{failed ? "Update could not finish. Please try again." : `Click to update ${getAppBranding().productName} now.`}</p>
        <small>Save your work before updating.</small>
      </div>
      <button type="button" onClick={handleUpdate} disabled={updating}>
        {updating ? "Updating…" : failed ? "Try again" : "Update"}
      </button>
    </section>
  );
}
